// Repeated page links scroll first, then reload only when already at the top.
export function handleCurrentPageNavigation(event, location) {
  const link = event.currentTarget;
  const target = link.getAttribute("target");
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey
    || event.shiftKey || event.altKey || (target && target !== "_self")
    || link.hasAttribute("download")) return;

  const destination = new URL(link.href, window.location.href);
  if (destination.origin !== window.location.origin
    || destination.pathname !== location.pathname
    || destination.search !== location.search
    || destination.hash !== location.hash) return;

  event.preventDefault();
  if (window.scrollY > 1) {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  } else {
    window.location.reload();
  }
}
